<div class="content center-text " role="main">
  <div id="header-breadcrumbs" class="header-breadcrumbs">
    <!-- Dynamic breadcrumb navigation -->
    <nav class="breadcrumb" aria-label="breadcrumb">
      <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
        <a *ngIf="!last && crumb.link" [routerLink]="crumb.link" class="breadcrumb-link">{{ crumb.label }}</a>
        <span *ngIf="last || !crumb.link" class="breadcrumb-current">{{ crumb.label }}</span>
        <span *ngIf="!last" class="breadcrumb-separator"> / </span>
      </ng-container>
    </nav>
  </div>
  <div id='ema-batch-view-header' class="ema-batch-view-header">
    <h2>Studio Pulse EMA Batch Details</h2>
    <p class="ema-batch-view-header-subtitle">
      The batch details page provides a comprehensive overview of the selected batch, including its deltas, errors, and
      line items. You can navigate through the tabs to view specific information related to the batch.
    </p>
  </div>
  <div class="search-bar-container">
    <!-- <input type="text" class="quick-search-input" placeholder="Search..." [(ngModel)]="searchInputValue" #search /> -->
    <!-- <nbcu-button id="clear-quick-search-button" [icon]="'clear'" (buttonClick)="[onClear()]"></nbcu-button> -->
    <!-- <nbcu-contained-button id="quick-search-button" icon="search"
      (buttonClick)="[onSearch(search.value)]"></nbcu-contained-button> -->
  </div>
  <div id="ema-batch-view-content" class="ema-batch-view-content">
    <mat-tab-group (selectedTabChange)="onTabChange($event)">
      <mat-tab label="Batch Line Items">
        <app-ema-batch-view-deltas></app-ema-batch-view-deltas>
      </mat-tab>
      <mat-tab label="Transmission Errors">
        <app-ema-batch-view-errors></app-ema-batch-view-errors>
      </mat-tab>
      <!-- <mat-tab label="Batch Line Items">
        <app-ema-batch-view-line-items></app-ema-batch-view-line-items>
      </mat-tab> -->
    </mat-tab-group>

  </div>
</div>